module.exports = "/_next/static/images/HeroCCPA@2x-144ad6d71e7ce9ae4e834f6be0d572df.webp";